<template>
  <div>
    <div
      v-for="(comment, index) in listOfComments"
      :key="index"
      :id="`individual-comment-${comment.id}`"
      class="flex px-5 py-6 w-full"
      :class="[
        index !== listOfComments.length - 1
          ? 'border-b border-solid border-gray-200'
          : '',
        index === 0 && comment.is_model_submission === false ? 'pt-0' : '',
      ]"
      v-show="
        !comment.is_hidden ||
        hasTeacherPermissionsInCourse ||
        owncomment(comment.user_id, comment.anonymous_identity_id)
      "
    >
      <div
        class="w-full"
        :class="
          $route.query.topLevelCommentID === comment.id &&
          !$route.query.replyCommentID &&
          isOpenReply === false
            ? 'bg-pinky-light bg-opacity-10 p-5 border-2 border-pinky'
            : ''
        "
      >
        <div :class="comment.is_hidden ? 'hidden-record' : ''">
          <CommentCard class="text-md mb-6" :submissionComment="comment" />
          <div v-if="comment.children" class="ml-16">
            <button
              v-if="!is_report_page && !studentInHardClosedRT"
              class="mr-2 px-5 py-2 rounded cursor-pointer text-xs font-semibold text-blueGray-800 border border-solid"
              :class="[selected_comment_id === comment.id
                  ? 'text-white border-blueGray-400'
                  : 'text-blueGray-800', fromGenieRecap && isGenieRecap ? 'bg-blueGray-200 hover:border-blueGray-400 border-blueGray-300 text-blueGray-600 hover:text-blueGray-900' : 'bg-gray-200 hover:border-gray-400 border-gray-300']"
              :id="`comment-reply-${comment.id}`"
              @click.prevent="
                toggleReplyField(comment.id, replysCount(comment.children))
              "
            >
              Replies ({{ replysCount(comment.children) }})
            </button>
            <button
              v-else
              class="mr-2 px-5 py-2 rounded bg-gray-100 cursor-pointer text-xs font-semibold"
              :class="[
                selected_comment_id === comment.id
                  ? 'text-white bg-blueGray-500'
                  : 'text-gray-400',
                comment.children.length === 0
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:text-white hover:bg-blueGray-500',
              ]"
              :disabled="comment.children.length === 0"
              @click.prevent="
                toggleReplyField(comment.id, replysCount(comment.children))
              "
            >
              Read Replies ({{ comment.children.length }})
            </button>
          </div>
        </div>
        <div
          v-if="selected_comment_id === comment.id"
          class="w-full mt-7 bg-transparent"
        >
          <CommentReplies
            :commentReplyToHighlightID="commentReplyToHighlightID"
            class="ml-12"
            :comment="comment"
          />
          <div
            v-if="!is_report_page && !studentInHardClosedRT"
            class="w-full flex justify-between pr-5 pl-16 pb-8"
            :class="[
              fromGenieRecap && isGenieRecap ? 'bg-blueGray-100' : 'bg-gray-100',
            ]"
          >
            <div
              class="w-full bg-white rounded focus-within:border-primary border border-coolGray-100"
            >
              <Textbox
                ref="reply-textbox"
                selectedRef="reply-textbox"
                :autoSave="true"
                :id="`reply-textbox-${comment.id}`"
                v-model="reply_content"
                :showSubmitButton="false"
                placeholder="Write a reply"
                @messageSent="submitReply(comment.id)"
                @saveChanges="saveChanges(comment.id)"
                :maxHeight="85"
              />
              <div
                class="flex relative justify-between items-center border-t border-coolGray-200 py-3 px-3"
              >
                <EmojiPicker
                  :search="searchEmoji"
                  @emoji="append"
                  class="emoji-container"
                >
                  <div
                    class="emoji-invoker"
                    slot="emoji-invoker"
                    slot-scope="{ events: { click: clickEvent } }"
                    @click.stop="clickEvent"
                  >
                    <button class="w-8 h-8 hover:bg-coolGray-200 rounded-full">
                      <i
                        class="fa-solid text-base text-gray-500 fa-face-grin"
                      ></i>
                    </button>
                  </div>
                  <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                    <div
                      class="emoji-picker absolute w-80 h-56 px-5 shadow rounded border border-coolGray-300 py-4 z-50 overflow-x-hidden overflow-y-auto bg-white"
                    >
                      <input
                        placeholder="Search"
                        type="text"
                        v-model="searchEmoji"
                        class="py-2 px-4 rounded w-full border-2 border-red-500"
                      />
                      <div>
                        <div
                          v-for="(emojiGroup, category) in emojis"
                          :key="category"
                        >
                          <h5>{{ category }}</h5>
                          <div class="emojis">
                            <span
                              v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click="insert(emoji)"
                              :title="emojiName"
                              >{{ emoji }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </EmojiPicker>
                <button
                  class="sample py-2 w-28 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
                  @click="submitReply(comment.id)"
                  :disabled="submitting"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import store from 'store';
  import $ from 'jquery';

  export default Vue.extend({
    components: {
      EmojiPicker: () => import('vue-emoji-picker'),
      CommentReplies: () => import('./commentReplies/commentReplies.vue'),
      CommentCard: () => import('./commentCard/commentCard.vue'),
      Textbox: () => import('components/textbox.vue'),
    },
    data() {
      return {
        reply_content: '',
        isOpenReply: false,
        selected_comment_id: null,
        timeOutId: null,
        submitting: false,
        searchEmoji: '',
      };
    },
    props: {
      listOfComments: {
        type: Array,
        default() {
          return [];
        },
      },
      submission: {
        type: Object,
        default() {
          return {};
        },
      },
      submissionID: {
        type: String,
        default: '',
      },
      commentToAutoExpandID: {
        type: String,
        default: '',
      },
      commentReplyToHighlightID: {
        type: String,
        default: '',
      },
      smallFont: {
        type: Boolean,
        default: false,
      },
      isInSummary: {
        type: Boolean,
        default: false,
      },
      fromGenieRecap: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getProfile',
        'studentInHardClosedRT',
        'getCurrentRT',
      ]),
      is_report_page() {
        return this.$route.name === 'course.student-summary';
      },
      isFromNotificationState() {
        return this.$store.state.isFromNotification;
      },
      genieRecap() {
        return this.getCurrentRT.genie_recap;
      },
      isGenieRecap() {
        return this.genieRecap.id ? true : false;
      },
    },
    methods: {
      append(emoji) {
        this.reply_content = this.reply_content + emoji;
      },
      toggleReplyField: async function (commentID, replies) {
        this.isOpenReply = true;
        if (this.selected_comment_id === commentID) {
          this.selected_comment_id = null;
          return;
        }
        this.selected_comment_id = commentID;
        this.reply_content = '';

        if (Object.keys(this.submission).length) {
          const comment = this.submission.comments.find(
            (c) => c.id === commentID
          );
          if (comment && comment.reply_content)
            this.reply_content = comment.reply_content;
        }
        // Only focus textbox if no replies
        if (replies === 0) {
          setTimeout(function () {
            $(`#reply-textbox-${commentID} textarea`).focus();
          }, 500);
        }
      },
      submitReply: async function (id) {
        if (this.reply_content.trim() === '') return;
        this.submitting = true;

        const members_channel =
          window.pusher.channels.channels[
            `presence-course-${this.$route.params.courseID}`
          ];
        let is_user_on_written = true;

        if (this.fromGenieRecap && this.isGenieRecap) {
          const genieRecap = this.getCurrentRT.genie_recap;
          const posted_comments = genieRecap.comments;
          const user_on_post_reply = posted_comments.filter(
            (comment) => comment.id === id
          );
          members_channel.members.each(function (member) {
            if (member.id === user_on_post_reply[0].user_id) {
              is_user_on_written = false;
            }
          });
          await this.$store
            .dispatch('postRecapComment', {
              user_id: this.getProfile.id,
              roundtable_id: this.$route.params.roundtableID,
              recap_id: this.genieRecap.id,
              content: this.reply_content,
              response_to: id,
              is_to_send_email: is_user_on_written,
              type: 'reply',
            })
            .finally(() => (this.submitting = false));
        } else {
          const submissions = this.getCurrentRT.submissions;
          const author_submission = submissions.filter(
            (submission) => submission.id === this.submission.id
          );
          const posted_comments = author_submission[0].comments;
          const user_on_post_reply = posted_comments.filter(
            (comment) => comment.id === id
          );
          members_channel.members.each(function (member) {
            if (member.id === user_on_post_reply[0].user_id) {
              is_user_on_written = false;
            }
          });
          await store
            .dispatch('postComment', {
              submission_id: this.submissionID,
              content: this.reply_content,
              response_to: id,
              is_to_send_email: is_user_on_written,
              type: 'reply',
            })
            .finally(() => (this.submitting = false));
        }

        if (!this.submitting) {
          this.reply_content = '';
          if (Object.keys(this.submission).length) {
            let submission = Object.assign({}, this.submission);
            let comment = submission.comments.find((c) => c.id === id);
            comment.reply_content = '';
            this.$store.commit('UPDATE_SUBMISSION_SPREAD', submission);
          }
        }
      },
      owncomment(userID, anonymousIdentityId) {
        return (
          this.getProfile.my_rt_user_details.id === userID ||
          this.getProfile.my_rt_user_details.id === anonymousIdentityId
        );
      },
      replysCount(comments) {
        let count = 0;
        if (comments && comments.length) {
          if (this.hasTeacherPermissionsInCourse) {
            count = comments.length;
          } else {
            comments.forEach((c) => {
              if (!c.is_hidden) {
                count = count + 1;
              } else if (
                c.is_hidden &&
                this.owncomment(c.user_id, c.anonymous_identity_id)
              ) {
                count = count + 1;
              }
            });
          }
        }
        return count;
      },
      saveChanges(comment_id) {
        clearTimeout(this.timeOutId);
        this.timeOutId = setTimeout(() => {
          if (this.submitting) return;
          // Runs 1 second (1000 ms) after the last change
          if (Object.keys(this.submission).length) {
            let submission = Object.assign({}, this.submission);
            let comment = submission.comments.find((c) => c.id === comment_id);
            comment.reply_content = this.reply_content;
            this.$store.commit('UPDATE_SUBMISSION_SPREAD', submission);
          }
        }, 1000);
      },
    },
    mounted: async function () {
      if (this.$router.query && this.isOpenReply === true) {
        this.$router.push({ name: 'roundtable.discussion' });
      }
      const { topLevelCommentID, from_email, replyCommentID } =
        this.$route.query;
      if (from_email === 'reply' || replyCommentID) {
        await this.toggleReplyField(topLevelCommentID, 0);
      }

      EventBus.$on('scrollToRecapReplyComment', async (comment_id) => {
        this.selected_comment_id = null;
        await this.toggleReplyField(comment_id, 0);
      });
    },
    beforeDestroy() {
      EventBus.$off('scrollToRecapReplyComment');
    },
  });
</script>

<!-- CSS -->
<style scoped lang="stylus">
  a
    color: pl-fountain-blue;
    font-weight: 400;

  .reply-btn-content
    padding: 0px 10px;
  .toggle-reply-btn {
    font-size: 12px;
    padding: 0px;
    margin: 0px;
  }

  .card-limit {
    border-bottom: 1px solid #f7f7f7
  }

  .see-all-model
    color: #58a4b0
    &&:hover
      cursor: pointer
      cursor: hand
      text-decoration: underline
</style>



// WEBPACK FOOTER //
// commentCardList.vue?4c9ca5ac